const ENDPOINT = 'SEARCHedge';
function SearchEdge(gateway, params) {
    return gateway.get(SearchEdge.endpoint, params);
}
SearchEdge.endpoint = ENDPOINT;

export { SearchEdge as default };
//# sourceMappingURL=searchEdge.js.map
